import {
  countUserRoles
} from "components/utils/policy";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../../redux/slice/auth.slice";
import { groupSelectors } from "../../../../redux/slice/group.slice";
import { FETCH_ALERT_POLICIES } from "../../../../redux/types/alertPolicy.types";
import { FETCH_GROUPS, GET_USER_INVITES, GET_USERS } from "../../../../redux/types/group.types";
import { FETCH_POLICIES } from "../../../../redux/types/policy.types";
import ManagementHeader from "../ManagementHeader/ManagementHeader";
import Groups from "./Groups/Groups";
import { getPortalManagementResources, getPortalNavItems, portalCardColors, USER_PERMISSIONS } from "./helper";
import Policies from "./Policies/Policies";
import Users from "./Users/Users";
import { accessActions } from "../../../../redux/slice/access.slice";
import { checkSinglePermission } from "components/shared/helper";

const PortalManagement = () => {
  const dispatch = useDispatch();
  const [selectedTab, handleSelectedTab] = useState(0);
  const groups = useSelector((state) => state.group.groups);
  const policies = useSelector((state) => state.policy.policies);
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)

  const users = useSelector(groupSelectors.getUsers);
  const invites = useSelector(groupSelectors.getInvites);

  useEffect(() => {
    dispatch({ type: FETCH_GROUPS });
    dispatch({ type: FETCH_POLICIES });
    dispatch({ type: FETCH_ALERT_POLICIES });
    dispatch({ type: GET_USERS });
    dispatch({ type: GET_USER_INVITES });
  }, [dispatch]);

  const refreshGroups = () => {
    dispatch({ type: FETCH_GROUPS });
  };

  const renderContent = (selectedTab) => {
    const tabLabel = portalNavItems[selectedTab]?.label;

    switch (tabLabel) {
      case "Groups":
        return <Groups refreshGroups={refreshGroups} />;
      case "Users":
        return (
          <Users
            user={users}
            invites={invites}
            groups={groups}
            refreshGroups={refreshGroups}
            currentUser={currentUser}
          />
        );
      case "Roles":
        return (
          <Policies
            policies={policies}
            groups={groups}
            refreshGroups={refreshGroups}
          />
        );
      default:
        return <Groups refreshGroups={refreshGroups} />;
    }
  };


  const resources = useMemo(() => {
    return getPortalManagementResources({ groups, users, policies });

  }, [groups, users, policies])


  const portalNavItems = getPortalNavItems({
    areGroupsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_PORTAL_GROUPS, userPermissions, currentUser?.role),
    areUsersAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_PORTAL_USERS, userPermissions, currentUser?.role),
    areRolesAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ROLES, userPermissions, currentUser?.role),
  })

  return (
    <div>
      <ManagementHeader
        selectedTab={selectedTab}
        handleSelectedTab={handleSelectedTab}
        userCount={users.length}
        roleCount={countUserRoles(users).length}
        resources={resources}
        cardColors={portalCardColors}
        navItems={portalNavItems}
      />
      {renderContent(selectedTab)}
    </div>
  );
};

export default PortalManagement;
